/* Giftagoods · How it works scroll story with a morphing 3D object (three.js r128) */
(function () {
  'use strict';
  if (window.__ggHowBoot) return;
  window.__ggHowBoot = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function sm(a, b, x) { var t = clamp((x - a) / (b - a), 0, 1); return t * t * (3 - 2 * t); }
  function lerp(a, b, t) { return a + (b - a) * t; }

  /* ═════════ HOW IT WORKS · scroll story ═════════ */
  function init(sec) {
    var cleanups = [];
    function cleanup() { cleanups.forEach(function (fn) { try { fn(); } catch (e) {} }); }
    var steps = [].slice.call(sec.querySelectorAll('.how-step'));
    var N = steps.length;
    var visual = sec.querySelector('.how-visual');
    var stage = sec.querySelector('.how-stage');
    if (!N || !visual || !stage) return cleanup;
    var canvas = stage.querySelector('canvas');
    var chipN = sec.querySelector('.how-chip-n'), chipT = sec.querySelector('.how-chip-t');
    var fbN = sec.querySelector('.how-fb-n'), fbT = sec.querySelector('.how-fb-t');
    var rail = sec.querySelector('.how-rail i');
    var segs = [].slice.call(sec.querySelectorAll('.how-seg i'));
    var nums = [].slice.call(sec.querySelectorAll('.how-num'));
    var P = 0, active = -1, ticking = false;
    sec.classList.add('live');

    function measure() {
      ticking = false;
      var vh = window.innerHeight;
      var vr = visual.getBoundingClientRect();
      var focus = window.innerWidth > 1000
        ? Math.min(vh * 0.56, (parseFloat(getComputedStyle(visual).top) || 104) + vr.height / 2)
        : (clamp(vr.bottom, 0, vh) + vh) / 2;
      var c = steps.map(function (s) { var r = s.getBoundingClientRect(); return r.top + r.height / 2; });
      var p = 0;
      if (focus >= c[N - 1]) p = N - 1;
      else if (focus > c[0]) {
        for (var i = 0; i < N - 1; i++) {
          if (focus >= c[i] && focus <= c[i + 1]) { p = i + (focus - c[i]) / (c[i + 1] - c[i]); break; }
        }
      }
      P = p;
      var a = Math.round(p);
      if (a !== active) {
        active = a;
        steps.forEach(function (s, i) {
          s.classList.toggle('is-active', i === a);
          s.classList.toggle('is-done', i < a);
        });
        var n = (a + 1 < 10 ? '0' : '') + (a + 1), name = steps[a].getAttribute('data-name');
        chipN.textContent = n; chipT.textContent = name;
        fbN.textContent = n; fbT.textContent = name;
      }
      sec.classList.toggle('moved', p > 0.12);
      segs.forEach(function (s, i) { s.style.transform = 'scaleX(' + clamp(p - i + 1, 0, 1).toFixed(4) + ')'; });
      if (rail) rail.style.transform = 'scaleY(' + (p / Math.max(N - 1, 1)).toFixed(4) + ')';
      if (!reduce) nums.forEach(function (el, i) {
        el.style.transform = 'translate3d(0,' + ((c[i] - focus) * -0.28).toFixed(1) + 'px,0)';
      });
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(measure); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    cleanups.push(function () { window.removeEventListener('scroll', onScroll); window.removeEventListener('resize', onScroll); });
    measure();

    /* ─── 3D object ─── */
    if (!window.THREE || sec.getAttribute('data-3d') === 'false') return cleanup;
    var T = window.THREE, renderer;
    try {
      renderer = new T.WebGLRenderer({ canvas: canvas, antialias: true, alpha: true, powerPreference: 'high-performance' });
    } catch (e) { return cleanup; }
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, window.innerWidth < 700 ? 1.75 : 2));
    renderer.outputEncoding = T.sRGBEncoding;
    renderer.toneMapping = T.ACESFilmicToneMapping;
    renderer.toneMappingExposure = 1.05;
    renderer.setClearColor(0x000000, 0);

    var scene = new T.Scene();
    var camera = new T.PerspectiveCamera(30, 1, 0.1, 50);
    var camZ = 6.2, lookY = -0.02;
    camera.position.set(0, 0.55, camZ);
    camera.lookAt(0, -0.02, 0);

    // Studio environment painted on a canvas, so reflections need no external files
    (function () {
      var c = document.createElement('canvas'); c.width = 1024; c.height = 512;
      var g = c.getContext('2d');
      var gr = g.createLinearGradient(0, 0, 0, 512);
      gr.addColorStop(0, '#34343c'); gr.addColorStop(0.42, '#0e0e12');
      gr.addColorStop(0.56, '#0a0908'); gr.addColorStop(1, '#3c2a0a');
      g.fillStyle = gr; g.fillRect(0, 0, 1024, 512);
      g.filter = 'blur(8px)';
      g.fillStyle = 'rgba(255,255,255,.96)';
      g.fillRect(110, 96, 180, 120);
      g.fillRect(640, 64, 110, 230);
      g.fillStyle = 'rgba(255,240,214,.85)'; g.fillRect(400, 18, 220, 36);
      g.fillStyle = 'rgba(255,198,26,.95)'; g.fillRect(868, 150, 84, 210);
      g.fillStyle = 'rgba(255,170,70,.55)'; g.fillRect(20, 200, 40, 140);
      var fb = g.createRadialGradient(512, 480, 10, 512, 480, 320);
      fb.addColorStop(0, 'rgba(255,186,60,.6)'); fb.addColorStop(1, 'rgba(255,186,60,0)');
      g.fillStyle = fb; g.fillRect(0, 280, 1024, 232);
      var tex = new T.CanvasTexture(c);
      tex.mapping = T.EquirectangularReflectionMapping;
      tex.encoding = T.sRGBEncoding;
      var pm = new T.PMREMGenerator(renderer);
      scene.environment = pm.fromEquirectangular(tex).texture;
      tex.dispose(); pm.dispose();
    })();

    scene.add(new T.AmbientLight(0xffffff, 0.12));
    var key = new T.DirectionalLight(0xfff0d0, 1.25); key.position.set(3, 4, 5); scene.add(key);
    var rim = new T.DirectionalLight(0xffc61a, 1.6); rim.position.set(-4, 2, -3); scene.add(rim);

    // Trophy silhouette: [t, radius, height], bottom centre to the inside of the cup
    var BX = 0.8, BH = 0.56, BY = -0.52;
    var PROF = [[0,0,-1.12],[.02,.5,-1.12],[.036,.565,-1.095],[.09,.585,-1.02],[.118,.56,-.945],[.134,.43,-.925],[.16,.405,-.865],[.184,.305,-.825],[.208,.265,-.745],[.232,.135,-.705],[.3,.088,-.52],[.378,.082,-.3],[.408,.15,-.245],[.438,.15,-.185],[.468,.088,-.125],[.52,.125,-.02],[.6,.3,.18],[.69,.47,.42],[.78,.59,.7],[.858,.66,.975],[.888,.682,1.075],[.91,.662,1.12],[.936,.6,1.085],[.968,.42,.93],[1,0,.8]];
    function prof(t) {
      var k = 0;
      while (k < PROF.length - 2 && t > PROF[k + 1][0]) k++;
      var p0 = PROF[Math.max(k - 1, 0)], p1 = PROF[k], p2 = PROF[k + 1], p3 = PROF[Math.min(k + 2, PROF.length - 1)];
      var u = clamp((t - p1[0]) / (p2[0] - p1[0]), 0, 1), u2 = u * u, u3 = u2 * u;
      function cr(i) {
        var m1 = (p2[i] - p0[i]) * 0.5, m2 = (p3[i] - p1[i]) * 0.5;
        return (2 * u3 - 3 * u2 + 1) * p1[i] + (u3 - 2 * u2 + u) * m1 + (-2 * u3 + 3 * u2) * p2[i] + (u3 - u2) * m2;
      }
      return [Math.max(cr(1), 0), cr(2)];
    }
    function rng(seed) {
      return function () {
        seed |= 0; seed = seed + 0x6D2B79F5 | 0;
        var t = Math.imul(seed ^ seed >>> 15, 1 | seed);
        t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t;
        return ((t ^ t >>> 14) >>> 0) / 4294967296;
      };
    }

    // One grid of vertices, three shapes: sphere (base), trophy, gift box, scattered cloud
    function shapeGeo(ws, hs, seed, asPoints) {
      var R = rng(seed), base = [], tro = [], box = [], sca = [], grid = [], idx = [];
      for (var iy = 0; iy <= hs; iy++) {
        var row = [], v = iy / hs, th = v * Math.PI;
        for (var ix = 0; ix <= ws; ix++) {
          if (asPoints && (iy === 0 || iy === hs || ix === ws)) { row.push(-1); continue; }
          var u = ix / ws, ph = u * Math.PI * 2;
          var sx = -Math.cos(ph) * Math.sin(th), sy = Math.cos(th), sz = Math.sin(ph) * Math.sin(th);
          base.push(sx, sy, sz);
          var pr = prof(1 - v);
          tro.push(-pr[0] * Math.cos(ph), pr[1], pr[0] * Math.sin(ph));
          var k = Math.pow(Math.pow(Math.abs(sx / BX), 12) + Math.pow(Math.abs(sy / BH), 12) + Math.pow(Math.abs(sz / BX), 12), -1 / 12);
          box.push(sx * k, sy * k + BY, sz * k);
          var r = 0.18 + Math.pow(R(), 0.75) * 1.25, a = R() * Math.PI * 2, b = Math.acos(2 * R() - 1);
          sca.push(r * Math.sin(b) * Math.cos(a) * 1.1, r * Math.cos(b) * 0.9 + 0.05, r * Math.sin(b) * Math.sin(a) * 1.1);
          row.push(base.length / 3 - 1);
        }
        grid.push(row);
      }
      var geo = new T.BufferGeometry();
      geo.setAttribute('position', new T.Float32BufferAttribute(base, 3));
      if (!asPoints) {
        for (iy = 0; iy < hs; iy++) for (ix = 0; ix < ws; ix++) {
          var A = grid[iy][ix + 1], B = grid[iy][ix], C = grid[iy + 1][ix], D = grid[iy + 1][ix + 1];
          if (iy !== 0) idx.push(A, B, D);
          if (iy !== hs - 1) idx.push(B, C, D);
        }
        geo.setIndex(idx);
      }
      var targets = [tro, box, sca].map(function (arr) { return new T.Float32BufferAttribute(arr, 3); });
      geo.morphAttributes.position = targets;
      if (!asPoints) {
        geo.computeVertexNormals();
        geo.morphAttributes.normal = [tro, box, base].map(function (arr) { return weldedNormals(arr, idx); });
        geo.attributes.normal = weldedNormals(base, idx);
      }
      return geo;
    }
    // Smooth normals across the UV seam and the poles by averaging vertices that share a position
    function weldedNormals(arr, idx) {
      var g = new T.BufferGeometry();
      g.setAttribute('position', new T.Float32BufferAttribute(arr, 3));
      g.setIndex(idx); g.computeVertexNormals();
      var n = g.attributes.normal.array, acc = {}, keys = [], i, kx;
      for (i = 0; i < arr.length; i += 3) {
        kx = arr[i].toFixed(3) + ',' + arr[i + 1].toFixed(3) + ',' + arr[i + 2].toFixed(3);
        keys.push(kx);
        var s = acc[kx] || (acc[kx] = [0, 0, 0]);
        s[0] += n[i]; s[1] += n[i + 1]; s[2] += n[i + 2];
      }
      var out = new Float32Array(arr.length);
      for (i = 0; i < keys.length; i++) {
        var q = acc[keys[i]], l = Math.hypot(q[0], q[1], q[2]) || 1;
        out[i * 3] = q[0] / l; out[i * 3 + 1] = q[1] / l; out[i * 3 + 2] = q[2] / l;
      }
      g.dispose();
      return new T.Float32BufferAttribute(out, 3);
    }

    var obj = new T.Group(); scene.add(obj);
    obj.scale.setScalar(0.94);

    var CHROME = new T.Color(0xffffff), GOLD = new T.Color(0xffc61a).convertSRGBToLinear();
    var solidMat = new T.MeshPhysicalMaterial({
      color: 0xffffff, metalness: 1, roughness: 0.13, envMapIntensity: 1.15,
      clearcoat: 0, clearcoatRoughness: 0.12, transparent: true, opacity: 0,
      morphTargets: true, morphNormals: true
    });
    var solid = new T.Mesh(shapeGeo(160, 120, 1, false), solidMat);
    obj.add(solid);

    var wireMat = new T.MeshBasicMaterial({ color: 0xffffff, wireframe: true, transparent: true, opacity: 0.12, morphTargets: true, depthWrite: false, toneMapped: false });
    var wire = new T.Mesh(shapeGeo(40, 30, 2, false), wireMat);
    wire.scale.setScalar(1.004);
    obj.add(wire);

    var dot = document.createElement('canvas'); dot.width = dot.height = 64;
    var dg = dot.getContext('2d'), rg = dg.createRadialGradient(32, 32, 0, 32, 32, 32);
    rg.addColorStop(0, 'rgba(255,255,255,1)'); rg.addColorStop(0.35, 'rgba(255,255,255,.85)'); rg.addColorStop(1, 'rgba(255,255,255,0)');
    dg.fillStyle = rg; dg.fillRect(0, 0, 64, 64);
    var ptsMat = new T.PointsMaterial({
      color: 0xffd24d, size: 0.034, map: new T.CanvasTexture(dot), transparent: true, opacity: 0.95,
      depthWrite: false, blending: T.AdditiveBlending, morphTargets: true, sizeAttenuation: true, toneMapped: false
    });
    var pts = new T.Points(shapeGeo(96, 72, 3, true), ptsMat);
    obj.add(pts);

    // Ribbon and bow for the delivery box
    var ribMat = new T.MeshPhysicalMaterial({ color: 0x0c0c0e, metalness: 0.1, roughness: 0.38, envMapIntensity: 0.5, clearcoat: 1, clearcoatRoughness: 0.2, transparent: true, opacity: 0 });
    var ribbon = new T.Group();
    var bandA = new T.Mesh(new T.BoxGeometry(BX * 2 + 0.03, BH * 2 + 0.03, 0.22), ribMat);
    var bandB = new T.Mesh(new T.BoxGeometry(0.22, BH * 2 + 0.03, BX * 2 + 0.03), ribMat);
    ribbon.add(bandA, bandB);
    [0, 1, 2, 3].forEach(function (q) {
      var pivot = new T.Group();
      pivot.position.y = BH + 0.02;
      pivot.rotation.y = q * Math.PI / 2 + Math.PI / 4;
      var loop = new T.Mesh(new T.TorusGeometry(0.2, 0.05, 16, 44), ribMat);
      loop.scale.set(1.25, 0.72, 1);
      loop.position.set(0.24, 0.1, 0);
      loop.rotation.z = 0.42;
      pivot.add(loop);
      ribbon.add(pivot);
    });
    var knot = new T.Mesh(new T.SphereGeometry(0.1, 24, 16), ribMat); knot.position.y = BH + 0.05; knot.scale.set(1, 0.7, 1);
    ribbon.add(knot);
    ribbon.position.y = BY;
    obj.add(ribbon);

    var floor = new T.GridHelper(3.6, 18, 0xffc61a, 0x3a3a42);
    floor.position.y = -1.13;
    floor.material.transparent = true; floor.material.opacity = 0; floor.material.depthWrite = false; floor.material.toneMapped = false;
    scene.add(floor);

    var gc = document.createElement('canvas'); gc.width = gc.height = 256;
    var gg = gc.getContext('2d'), gr2 = gg.createRadialGradient(128, 128, 0, 128, 128, 128);
    gr2.addColorStop(0, 'rgba(255,198,26,.9)'); gr2.addColorStop(0.45, 'rgba(255,160,40,.28)'); gr2.addColorStop(1, 'rgba(255,160,40,0)');
    gg.fillStyle = gr2; gg.fillRect(0, 0, 256, 256);
    var glow = new T.Mesh(new T.PlaneGeometry(3.4, 3.4), new T.MeshBasicMaterial({ map: new T.CanvasTexture(gc), transparent: true, opacity: 0.5, depthWrite: false, blending: T.AdditiveBlending, toneMapped: false }));
    glow.rotation.x = -Math.PI / 2; glow.position.y = -1.15;
    scene.add(glow);

    function resize() {
      var w = stage.clientWidth, h = stage.clientHeight;
      if (!w || !h) return;
      renderer.setSize(w, h, false);
      camera.aspect = w / h;
      camZ = h < 480 ? 7.1 : camera.aspect < 0.78 ? 6.9 : camera.aspect > 1.3 ? 5.8 : 6.2;
      lookY = h < 480 ? 0.14 : -0.02;
      camera.position.z = camZ;
      camera.updateProjectionMatrix();
    }
    resize();
    if ('ResizeObserver' in window) { var rso = new ResizeObserver(resize); rso.observe(stage); cleanups.push(function () { rso.disconnect(); }); }
    else { window.addEventListener('resize', resize); cleanups.push(function () { window.removeEventListener('resize', resize); }); }

    var tilt = { x: 0, y: 0, tx: 0, ty: 0 };
    stage.addEventListener('pointermove', function (e) {
      var r = stage.getBoundingClientRect();
      tilt.ty = ((e.clientX - r.left) / r.width - 0.5) * 0.5;
      tilt.tx = ((e.clientY - r.top) / r.height - 0.5) * 0.22;
    });
    stage.addEventListener('pointerleave', function () { tilt.tx = tilt.ty = 0; });

    var S = 0, time = 0, last = 0, running = false, first = true;
    function targetS() {
      var Q = P * 3 / Math.max(N - 1, 1);
      if (Q >= 3) return 3;
      var seg = Math.floor(Q);
      return seg + sm(0.3, 0.7, Q - seg);
    }
    function frame(now) {
      if (!running) return;
      requestAnimationFrame(frame);
      var dt = last ? Math.min((now - last) / 1000, 0.1) : 0.016; last = now;
      if (!reduce) time += dt;
      var tS = targetS();
      S = reduce ? tS : S + (tS - S) * Math.min(1, dt * 4.5);

      var wT = S <= 1 ? sm(0, 1, S) : S <= 2 ? 1 : 1 - sm(2, 3, S);
      var wB = sm(2, 3, S);
      var wS = S <= 1 ? 1 - wT : 0;
      solid.morphTargetInfluences[0] = wT; solid.morphTargetInfluences[1] = wB; solid.morphTargetInfluences[2] = 0;
      wire.morphTargetInfluences[0] = wT; wire.morphTargetInfluences[1] = wB; wire.morphTargetInfluences[2] = 0;
      pts.morphTargetInfluences[0] = wT; pts.morphTargetInfluences[1] = wB; pts.morphTargetInfluences[2] = wS;

      ptsMat.opacity = S <= 1 ? lerp(1, 0.45, S) : 0.45 * (1 - sm(1, 1.7, S));
      ptsMat.size = lerp(0.05, 0.03, sm(0, 1, S));
      pts.visible = ptsMat.opacity > 0.005;
      var wireIn = sm(0, 1, S);
      wireMat.opacity = lerp(0, 0.7, sm(0.25, 1, S)) * (1 - sm(1.2, 1.95, S));
      wireMat.color.setRGB(1, lerp(1, 0.78, wireIn), lerp(1, 0.1, wireIn));
      wire.visible = wireMat.opacity > 0.005;
      var so = sm(1.1, 1.9, S);
      solidMat.opacity = so; solidMat.depthWrite = so > 0.5; solid.visible = so > 0.005;
      var gold = sm(2.1, 2.85, S);
      solidMat.color.copy(CHROME).lerp(GOLD, gold);
      solidMat.metalness = lerp(1, 0.25, gold);
      solidMat.roughness = lerp(0.13, 0.3, gold);
      solidMat.clearcoat = gold;
      var ro = sm(2.55, 2.97, S);
      ribMat.opacity = ro; ribbon.visible = ro > 0.005;
      ribbon.scale.setScalar(lerp(1.14, 1, ro));
      floor.material.opacity = 0.4 * sm(0.3, 1, S) * (1 - sm(1.3, 2, S));
      floor.visible = floor.material.opacity > 0.005;
      glow.material.opacity = 0.35 + 0.25 * sm(1.5, 2.2, S);

      tilt.x += (tilt.tx - tilt.x) * Math.min(1, dt * 3);
      tilt.y += (tilt.ty - tilt.y) * Math.min(1, dt * 3);
      var lift = sm(2.2, 3, S);
      camera.position.set(0, lerp(0.55, 2.3, lift), lerp(camZ, camZ - 0.35, lift));
      camera.lookAt(0, lerp(lookY, lookY - 0.4, lift), 0);
      obj.rotation.y = time * 0.28 + S * 1.15 + tilt.y;
      obj.rotation.x = tilt.x;
      obj.position.y = Math.sin(time * 1.1) * 0.03;

      renderer.render(scene, camera);
      if (first) { first = false; stage.classList.add('gl-ready'); }
    }
    function start() { if (!running) { running = true; last = 0; requestAnimationFrame(frame); } }
    function stop() { running = false; }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { e.isIntersecting ? start() : stop(); }); }, { rootMargin: '100% 0px' });
      io.observe(stage);
      cleanups.push(function () { io.disconnect(); });
    } else start();
    cleanups.push(function () { stop(); renderer.dispose(); });
    return cleanup;
  }

  function boot(scope) {
    (scope || document).querySelectorAll('.gg-how').forEach(function (sec) {
      if (sec.__ggHow) return;
      sec.__ggHow = init(sec) || function () {};
    });
  }
  boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('.gg-how').forEach(function (sec) { if (sec.__ggHow) { sec.__ggHow(); sec.__ggHow = null; } });
  });
})();